{
  "": "",
  "actions": {
    "update": "Update",
    "updated": "Updated"
  },
  "buttons": {
    "accept": "Confirm",
    "addEmail": "Add email",
    "addMultipleItems": "Add Multiple Items",
    "assignTicket": "Assign ticket",
    "assignTicketOfName": "Assign ticket {name}",
    "attach": "Attach",
    "cancel": "Cancel",
    "checklistContinueAnyway": "Not everything solved: Continue anyway",
    "checklistUndoContinue": "Solve open tasks",
    "connect": "Connect",
    "delete": "Delete",
    "downloadFile": "Download file",
    "downloadFileWithName": "Download \"{name}\"",
    "enterNegotiationMode": "Enter negotiation mode",
    "exitNegotiationMode": "Exit negotiation mode",
    "export": "Export",
    "exportCSV": "Export as CSV",
    "hide": "Hide",
    "large": "Large",
    "load": "Load",
    "lockUnlocked": "Ready - lock",
    "makeReadyToSign": "Notify signers",
    "newTicket": "New ticket",
    "nextProcessStep": "To next step",
    "nextStep": "To next step",
    "no": "No",
    "normal": "Normal",
    "reject": "Cancel",
    "revert": "Revert",
    "save": "Save",
    "saveAndCreateNext": "Save and create next",
    "selectAttachments": "Attachments",
    "selectUnrelatedAttachments": "Select unrelated attachments",
    "send": "Send",
    "show": "Show",
    "showLess": "Show less",
    "showMore": "Show more",
    "small": "Small",
    "uiPluginContinueAnyway": "Not everything solved: Continue anyway",
    "uiPluginUndoContinue": "Solve this task",
    "unlockLocked": "Not ready - unlock anyway",
    "update": "Update",
    "yes": "Yes"
  },
  "confirm": {
    "default": {
      "header": "Confirm",
      "message": "Do you want to proceed?"
    },
    "delete": {
      "header": "Delete entry",
      "message": "Do you really want to delete this entry?"
    },
    "deleteTicketRelation": {
      "header": "Delete entry with ticket relation",
      "message": "Do you really want to delete this entry? It has a relation to a ticket which will be deleted as well."
    },
    "nextStep": {
      "header": "Did you finish this part of the task?",
      "message": "You cannot revert this step afterwards"
    },
    "save": {
      "header": "Save entry",
      "message": "Do you really want to save this entry?"
    }
  },
  "enums": {
    "AC_BLUEPRINT": "Blueprint sample",
    "AC_BLUEPRINT_MULTIPLE": "Blueprint (many instances)",
    "AC_CHECKLIST": "Checklist",
    "AC_CONTRACTS": "Contracts",
    "AC_COSTSTATEMENTINVOICE": "Cost statement invoice",
    "AC_DOCUMENTUPLOAD": "Upload",
    "AC_EMAIL": "Email",
    "AC_LOCATIONLIST": "Location list",
    "AC_NONE": "No connected plugin",
    "AC_SKETCH": "Sketch component",
    "AC_STAMPING": "Stamping",
    "AC_UPLOAD": "Document upload",
    "AC_YOUSIGN": "YouSign",
    "ACTIVE": "Active",
    "AD_SPACE": "Ad space",
    "ADDITIONALCOSTADVANCEPAYMENT": "Additional cost advance payment",
    "ADDITIONALCOSTFLATRATE": "Additional cost flat rate",
    "ADDITIONALCOSTFLATRATEEURO": "Additional cost flat rate euro",
    "ADDITIONALCOSTFLATRATEPERCENTAGE": "Additional cost flat rate percentage",
    "ADMINISTRATIVECOSTS": "Administrative cost",
    "ADMINISTRATIVENOTICE": "Administrative Notice",
    "ADVERTISING": "Advertising",
    "ADVERTISINGASSOCIATION": "Advertising Association",
    "ADVERTISINGCOSTS": "Advertising costs",
    "ANCILLARY_AREA": "Ancillary area",
    "AREA": "Area",
    "ASSIGN_TEAM": "Assign a team",
    "AUTOMATIC": "Automatic",
    "AUTOMATIC_EXTENSION": "Automatic extension",
    "AVAILABLE": "Available",
    "BASERENT": "Base rent",
    "CENTER_MANAGEMENT": "Center Management",
    "CENTERMANAGEMENT": "Center management",
    "CLARIFIED": "Clarified",
    "CLEAR": "Clear",
    "CLOSED": "closed",
    "COMMERCIALBUILDING": "Commercial building",
    "COMMERCIALCENTRE": "Commercial centre",
    "COMPLETED": "Finished",
    "CONCESSION_AREA": "Consession area",
    "CREDITOR_PAYEE_": "Creditor (Payee)",
    "DAY": "Day | Days",
    "DAY_S": "{count} day | {count} days",
    "DE": "German",
    "DEADLINE_COUNTDOWN": "{count} day remains | {count} days remaining",
    "DEADLINE_OVERDUE": "Deadline expires on {date}",
    "DEADLINE_OVERDUE_WARN": "Overdue! Deadline: {date}",
    "DEADLINE_TRIGGER": "Deadline trigger for step",
    "DISCOUNT_PERCENTAGE": "Discount",
    "DR_": "Dr",
    "EN": "English",
    "ENGLISH": "English",
    "FACILITYMANAGER": "Facility Manager",
    "FMCONTACTDATA": "Facility Management Contact Data",
    "FMCONTRACT": "Facility Management Contract",
    "FMDUNNINGNOTICE": "Facility Management Reminder",
    "FMINCIDENTREPORT": "Facility Management Incident Report",
    "FMINSPECTIONREPORT": "Facility Management Inspection Report",
    "FMINVOICE": "Facility Management Invoice",
    "FMMISCCORRESPONDENCE": "Miscellaneous Facility Management Correspondence",
    "FMOFFER": "Facility Management Offer",
    "FMPHOTOS": "Facility Management Photos",
    "FMPLANS": "Facility Management Plans (Layout, Equipment)",
    "FR": "French",
    "FRAMEWORKAGREEMENTS": "Framework agreements",
    "FRENCH": "French",
    "GASTRONOMY": "Gastronomy",
    "GERMAN": "German",
    "GROUNDRENT": "Ground rent",
    "HEATINGCOSTADVANCE_PAYMENT": "Heating cost advance payment",
    "HEATINGCOSTADVANCEPAYMENT": "Heating cost advance payment",
    "HIGH": "high",
    "HU": "Hungarian",
    "HUNGARIAN": "Hungarian",
    "IN_CLARIFICATION": "In clarification",
    "IN_PROGRESS": "in progress",
    "IN_PROGRESS_OVERDUE": "in progress overdue",
    "IN_PROGRESS_OVERDUE_WARN": "way overdue",
    "INCLARIFICATION": "In clarification",
    "INSPECTION": "Inspection",
    "IS_ACTIVE": "Active",
    "LANDLORD": "Landlord",
    "LANDLORD_MANAGER": "Landlord Manager",
    "LEASE": "Leasing",
    "LEASE_CONTRACT": "Lease contract",
    "LEASEADDITIONALAGREEMENTS": "Additional Agreements",
    "LEASEAGREEMENT": "Lease Agreement",
    "LEASECONTACTDATA": "Contact Data",
    "LEASECONTRACTMISCCORRESPONDENCE": "Miscellaneous Lease Correspondence",
    "LEASEHANDOVERREPORT": "Handover Report",
    "LEASEHOLD": "Leasehold",
    "LEASEOPTIONOREXTENSIONLETTER": "Option or Extension Letter",
    "LEASEOWNERORCONTACTCHANGE": "Change of Owner or Contact",
    "LEASEPREVIOUSAGREEMENT": "Previous Lease Agreement",
    "LEASERENTADJUSTMENT": "Rent Adjustment",
    "LEASERENTDUNNINGNOTICE": "Rent Reminder",
    "LEASERENTINDEXINVOICE": "Index Rent Invoice",
    "LEASERENTINDEXLETTER": "Index Rent Letter",
    "LEASERENTINVOICE": "Rent Invoice",
    "LEASERETURNHANDOVERREPORT": "Return Handover Report",
    "LEASESECURITYDEPOSIT": "Security Deposit",
    "LEASESPECIALUSEAGREEMENT": "Special Use Agreement",
    "LEASESUPPLEMENT": "Contract Supplement",
    "LEASETERMINATIONLETTER": "Termination Letter",
    "LOG_TRIGGER": "Logging-Trigger",
    "LOGISTIC": "Logistic",
    "LOW": "low",
    "MAIN_AREA": "Main area",
    "MAINTENANCE": "Maintenance",
    "MAINTENANCE_CONTRACT": "Maintenance contract",
    "MAINTENANCECONTRACT": "Maintenance contract",
    "MEDICALFACILITY": "Medical facility",
    "MEDIUM": "medium",
    "MINIMUMRENT": "Minimum rent",
    "MISCELLANEOUSCORRESPONDENCE": "Miscellaneous Correspondence",
    "MONTH": "Month | Months",
    "MONTH_S": "{count} month | {count} months",
    "MR_": "Mr",
    "MRS_": "Mrs",
    "MS_": "Ms",
    "NEW": "new",
    "NONE": "-",
    "OFFICE_ADMINISTRATION": "Office/Administration",
    "OFFICEBUILDING": "Office building",
    "OPEN": "open",
    "OPEN_OVERDUE": "overdue",
    "OPEN_OVERDUE_WARN": "way overdue",
    "OPERATINGCOSTCORRECTION": "Service Charge Correction",
    "OPERATINGCOSTCREDITNOTE": "Service Charge Credit Note",
    "OPERATINGCOSTINVOICE": "Service Charge Statement",
    "OPERATINGCOSTMISCCORRESPONDENCE": "Miscellaneous Service Charge Correspondence",
    "OPERATINGCOSTOBJECTIONLETTER": "Service Charge Objection Letter",
    "OPERATINGCOSTSUPPORTINGDOCUMENTS": "Service Charge Supporting Documents",
    "OPERATIONALEQUIPMENTLEASE": "Operational Equipment Lease",
    "OTHER": "Other",
    "OTHER_APARTMENTS": "Other/Apartments",
    "OTHER_USE": "Other use",
    "OUTLET": "Outlet",
    "OVERDUE": "overdue",
    "OVERDUE_WARN": "overdue",
    "OWNER": "Owner",
    "PARKING_AREA": "Parking area",
    "PARKINGSPACE": "Parking space",
    "PARKINGSPACERENTAL": "Parking space rental",
    "PARTLY": "in progress",
    "PERMANENTUSERIGHT": "Permanent use right",
    "PRACTICE": "Practice",
    "PRIORITY_LEVEL": "priority",
    "PROCESSED": "categorized",
    "PROF_": "Prof",
    "PROF_DR_": "Prof Dr",
    "PROPERTY_LANDLORD": "Property Landlord",
    "PROPERTY_MANAGER": "Property Manager",
    "PROPERTY_OWNER": "Property Owner",
    "PROPERTY_TENANT": "Property Tenant",
    "PROPERTYMANAGER": "Property Manager",
    "PURCHASE_AGREEMENT": "Purchase agreement",
    "REGION": "region",
    "RENTAL": "Rental",
    "RETAILCENTER": "Retail center",
    "SALES": "Sales",
    "SERVICE_AGREEMENT": "Service agreement",
    "SERVICE_CONTRACT_TYPE": "Service contract type",
    "SERVICECONTRACTINTERNETORPHONE": "Internet or phone",
    "SERVICECONTRACTPOSTCLEANINGREQUIRED": "Post cleaning required",
    "SERVICEPROVIDER": "Service Provider",
    "SKIP": "Skipped",
    "SPECIAL_RESILIATION": "Special resiliation",
    "SPECIALUSEPERMIT": "Special Use Permit",
    "SPECIALUSEPERMITWITHBOOKING": "Special Use Permit with Booking",
    "STANDALONE": "Standalone",
    "START_DATE": "Startdatum",
    "STORAGE": "Storage",
    "STORAGECONTRACT": "Storage contract",
    "SUBLEASE": "Sublease",
    "SUPPLYCONTRACT": "Supply contract",
    "TEAM_BO": "Back Office",
    "TEAM_BUHA": "Accounting",
    "TEAM_BUHA_CUST": "Customer Accounting",
    "TEAM_FM": "Facility Management",
    "TEAM_FM_CUST": "Customer Facility Management",
    "TEAM_FOMA": "Debt Collection",
    "TEAM_MVM": "Lease Management",
    "TEAM_MVM_LAW": "Lease Management Legal",
    "TEAM_MVM_LAWYER": "Lease Management Legal",
    "TEAM_NKA": "Service Charge Management",
    "TEAM_NKA_CUST": "Customer Service Charges",
    "TEAM_NONE": "No team assigned",
    "TENANT": "Tenant",
    "TENANT_AND_LANDLORD": "Tenant and Landlord",
    "TENANT_OR_LANDLORD": "Tenant or Landlord",
    "TERMINATION": "Termination",
    "TICKETSTATUS_CLOSED": "closed",
    "TICKETSTATUS_IN_PROGRESS": "in progress",
    "TICKETSTATUS_IN_PROGRESS_OVERDUE": "in progress overdue",
    "TICKETSTATUS_IN_PROGRESS_OVERDUE_WARN": "way overdue",
    "TICKETSTATUS_NEW": "new",
    "TICKETSTATUS_OPEN": "open",
    "TICKETSTATUS_OPEN_OVERDUE": "due",
    "TICKETSTATUS_OPEN_OVERDUE_WARN": "overdue",
    "TICKETSTATUS_OVERDUE": "due",
    "TICKETSTATUS_OVERDUE_WARN": "overdue",
    "TURNOVERBASEDRENT": "Turnover based rent",
    "TURNOVERBASEDRENTADVANCEPAYMENT": "Turnover based rent advice payment",
    "UNAVAILABLE": "Unavailable",
    "UNCLEAR": "Unclear",
    "UNPROCESSED": "uncategorized",
    "UTILITY_MANAGER": "Utility Manager",
    "WEEK": "Week | Weeks",
    "WEEK_S": "{count} week | {count} weeks",
    "WIDGET_EMAIL_CLASSIFIED": "uncategorized",
    "WIDGET_EMAIL_NOT_CLASSIFIED": "categorized",
    "WIDGET_STATUS_CLOSED": "closed",
    "WIDGET_STATUS_IN_PROGRESS": "in progress",
    "WIDGET_STATUS_IN_PROGRESS_OVERDUE": "overdue",
    "WIDGET_STATUS_IN_PROGRESS_OVERDUE_WARN": "way overdue",
    "WIDGET_STATUS_NEW": "new",
    "WIDGET_STATUS_OPEN": "open",
    "WIDGET_STATUS_OPEN_OVERDUE": "overdue, unprocessed",
    "WIDGET_STATUS_OPEN_OVERDUE_WARN": "way overdue, still unprocessed",
    "WIDGET_STATUS_OVERDUE": "overdue",
    "WIDGET_STATUS_OVERDUE_WARN": "way overdue",
    "WIDGET_STATUS_TICKETSTATUS_CLOSED": "closed",
    "YEAR": "Year | Years",
    "YEAR_S": "{count} year | {count} years",
    "YOUSIGN_DONE": "signed",
    "YOUSIGN_ONGOING": "pemding"
  },
  "errors": {
    "CANNOT_BE_CREATED": "Element cannot be created",
    "CANNOT_BE_DELETED": "Element cannot be deleted",
    "CANNOT_BE_FOUND": "Element cannot be found",
    "CANNOT_BE_UPDATED": "Element cannot be updated",
    "dateBeforeIssueDate": "The date is before the issue date",
    "dateBeforeObjectionDeadline": "The internal objection deadline is before the objection deadline",
    "invalidIban": "This is no valid IBAN",
    "issueDateBeforePeriodEnd": "The issue date is before the end of the period",
    "netGreaterThanGross": "Der Nettobetrag kann nicht größer als der Bruttobetrag sein",
    "periodEndBeforeStart": "The end of the period is before the start",
    "required": "This field is required",
    "validation": {
      "invalidDateInput": "No valid date"
    }
  },
  "info": {
    "SUCCESS_CREATE": "Element has been successfully created",
    "SUCCESS_DELETE": "Element has been successfully deleted",
    "SUCCESS_UPDATE": "Element has been successfully updated"
  },
  "labels": {
    "accountingArea": "Accounting area",
    "actingBy": "Acting by",
    "action": "Action",
    "actions": "Actions",
    "actionStart": "Action start",
    "activate": "Activate",
    "active": "Active",
    "add": "New entry",
    "additionalAddressInfo": "Additional address info",
    "addPositionChild": "Add child position",
    "address": "Address",
    "addresses": "Addresses",
    "addressId": "Address ID",
    "addressIdShort": "AID",
    "addTrigger": "New trigger",
    "adjustmentInterval": "Adjustment interval",
    "adjustmentPossible": "Adjustment possible",
    "advancedFilters": "Advanced filters",
    "allComments": "All comments",
    "alldocuments": {
      "add": "Upload"
    },
    "allIDs": "IDs Documents & Mails",
    "allIDsShort": "IDs",
    "allNamesAndSubjects": "Subject",
    "allocationSpace": "Allocation space",
    "amount": "Amount",
    "answerIsRequired": "Answer is required",
    "approvalNr": "Approval nr.",
    "area": "Area",
    "areaCount": "Area count",
    "areaDesignation": "Area designation",
    "areaName": "Name",
    "areaNameExternal": "External area name",
    "areas": "Areas",
    "areaSize": "Area size",
    "areasToContracts": "Areas",
    "areaToPointOfSale": "Point of sales",
    "asc": "Ascending",
    "assignee": "Assignee",
    "assignTicket": "Assign to '{name}'",
    "assignTicketStatic": "Assign to ticket",
    "attachedDocuments": "Attached documents",
    "attachment": "Attachment",
    "attachments": "Attachments",
    "autoAssigned": "Autoassigned",
    "automaticAdjustment": "Automatic adjustment",
    "backPayment": "Back payment",
    "bankName": "Bank name",
    "batchClassify": "Batch classification of documents",
    "bic": "BIC",
    "boardName": "Board name",
    "booleanValue": "Boolean value",
    "booleanValueShort": "Bool",
    "branchnumber": "Branch number",
    "brevoApiKey": "Brevo API key",
    "brevoCc": "Receivers of copy",
    "brevoReplyTo": "Reply to",
    "brevoSelectedTemplate": "Selected template",
    "brevoTemplate": "Email template",
    "brevoTo": "Sending to",
    "calculationStartDate": "Calculation start date",
    "caretaker": "Caretaker",
    "changeClassification": "Change classification",
    "changedAt": "Changed",
    "changes": "Changes",
    "chartCollapseAll": "Collapse all",
    "chartExpandAll": "Expand all",
    "chartFromStore": "Restore last view",
    "checklistItems": "Checklist",
    "checklistTopic": "Check condition",
    "checksumSHA256": "Checksum",
    "children": "Children",
    "chooseFile": "Choose file",
    "chooseFiles": "Choose files",
    "city": "City",
    "cityName": "City name",
    "cityZip": "City zip",
    "classificationStatus": "Status",
    "code": "Code",
    "columnName": "Column name",
    "combinedCount": "Counts",
    "combinedExtensionValue": "Extension",
    "combinedNoticePeriod": "Notice period",
    "combinedValue": "Condition value",
    "comment": "Comment",
    "comments": "Comments",
    "commentPublic": "Visible for customer users",
    "commentText": "Comment text",
    "privateComment": "Private",
    "publicComment": "Public",
    "companies": "Companies",
    "company": "Company",
    "companyCount": "Company count",
    "companyCountShort": "No.",
    "companyName": "Company name",
    "complete": "Complete",
    "conditions": "Contract conditions",
    "conditionType": "Condition type",
    "conditionTypeId": "Condition type ID",
    "connectedBy": "Connected by {source}",
    "constructionYear": "Construction year",
    "consumerPriceIndex": "Price index",
    "contact": "Contact",
    "contactPerson": "Contact person",
    "contactPersonToContract": "Contact person",
    "contains": "Contains",
    "content": "Content",
    "contract": "Contract",
    "contractAction": "Contract action",
    "contractactions": "Contract actions",
    "contractClauses": "Contract conditions",
    "contractConditions": "Contract conditions",
    "contractId": "ID of the Contract",
    "contractIdShort": "Contr.ID",
    "contractingParties": "Contracting parties",
    "contractName": "Contract name",
    "contractNames": "Contracts",
    "contracts": "Contracts",
    "contractsAreaValidity": "Applicable Region",
    "contractsDates": "Contract Duration",
    "contractsHeader": "General Contract Information",
    "contractsParties": "Parties Involved",
    "contractsPartiesGiver": "Contracting parties (Giver)",
    "contractsPartiesTaker": "Contracting parties (Taker)",
    "contractTemplate": "Contract template",
    "contracttodocuments": "Documents",
    "contractType": "Contract type",
    "contractTypeId": "Contract type ID",
    "contradictionPackages": "Contradiction packages",
    "contributionOneTime": "one-time contribution",
    "contributionRecurring": "recurring contribution",
    "cost": "Cost",
    "costCenter": "Cost center",
    "costsNet": "Costs net",
    "country": "Country",
    "countryCode": "Country code",
    "countryName": "Country name",
    "createdAt": "Created at",
    "currency": "Currency",
    "customer": "Customer",
    "customerAddress": "Address",
    "customerAmount": "Customer amount net",
    "customerAmountShort": "C. Amount",
    "customerAmountSuggestion": "Customer amount calc.",
    "customerArea": "Customer area",
    "customerAreaShort": "C. Area",
    "customerBankingAccount": "Customer banking account",
    "customerCode": "Customer code",
    "customerCount": "Customer count",
    "customerCountry": "Customer's country",
    "customerCountShort": "No.",
    "customerGroup": "Customer group",
    "customergroupDescription": "Description",
    "customerGroupId": "Customer group ID",
    "customerGroupName": "Customer group name",
    "customergroupName": "Customer group name",
    "customergroupNameShort": "Name",
    "customerGroups": "Customer groups",
    "customerId": "Customer ID",
    "customerIdShort": "C-ID",
    "customerName": "Customer name",
    "customerPrepaymentGross": "Customer prepayment gross",
    "customerPrepaymentNet": "Customer prepayment net",
    "customers": "Customers",
    "customerTemplate": "Customer template",
    "customerUnitArea": "Customer area",
    "dateValue": "Date",
    "dayOfMonth": "Day of month",
    "deActivate": "Deactivate",
    "deactivate": "Deactivate",
    "deadline": "Deadline",
    "deadlineOffset": "Deadline offset",
    "deadlineOverdue": "Deadline overdue",
    "deadlineRisk": "Deadline risk",
    "definiteActionEnd": "Last possible cancel date",
    "delete": "Delete",
    "deleteMany": "Delete {count} entry | Delete {count} entries",
    "desc": "Descending",
    "description": "Description",
    "descriptionUiPluginParam": "Sample description",
    "detailDescription": "Detailed description",
    "difference": "Difference",
    "discountPercentage": "Discount",
    "document": "Document",
    "documentId": "Document ID",
    "documentName": "Document Name",
    "documentReviewDeadline": "Document review deadline",
    "documents": "Documents",
    "documentType": "Document Type",
    "documentTypes": "Document types",
    "documentVersion": "Document version",
    "documentVersionShort": "V. Doc.",
    "downloadableTemplates": "Downloadable templates",
    "earliestEffectiveDate": "Earliest effective day",
    "edit": "Edit",
    "editChildPosition": "Edit child position",
    "editorName": "Editor",
    "effectiveDate": "Effective Date",
    "eMail": "Email",
    "email": "Email",
    "emailId": "Email ID",
    "emailLink": "Email link",
    "emails": "Emails",
    "endDate": "End date",
    "endsWith": "Ends with",
    "entryDate": "Entry date",
    "enumValue": "Enum value",
    "enumValueShort": "Enum",
    "equals": "Equals",
    "eventType": "Event type",
    "exportAll": "all",
    "exportAllColumns": "all",
    "exportColumnScope": "Columns",
    "exportDataType": "Data format",
    "exportFiltered": "filtered",
    "exportFormatted": "formatted",
    "exportLimit": "Export limit",
    "exportRaw": "raw",
    "exportScope": "Datasets",
    "exportVisibleColumns": "visible",
    "extension": "Extension",
    "extensionUnit": "Extension unit",
    "extensionValue": "Extention",
    "extensionValueShort": "Ext.",
    "extra": "Extra",
    "favAdd": "Save as favorite",
    "favRemove": "Remove favorite",
    "field": "Field",
    "fieldsToExport": "Fields to export",
    "fileName": "Filename",
    "filter": "Filter",
    "filtered": "filtered",
    "filterOnPOS": "Filter on point of sales",
    "filters": "Filters",
    "firstName": "First name",
    "firstPossibleEndDate": "First possible end date",
    "firstYear": "First year",
    "forCustomers": "for customers",
    "generalLeaderAccount": "General leader account",
    "generalLeaderAccountNr": "General leader account number",
    "germanFederalState": "Federal state",
    "grandTotal": "Grand Total",
    "greaterThan": "Greater than",
    "greaterThanOrEqual": "Greater than or equal",
    "group": "Group",
    "handOverDate": "Hand over date",
    "hasInternetOrPhone": "Has internet or phone",
    "hasNotifications": "Notifications",
    "history": "History",
    "houseNumber": "House number",
    "iban": "IBAN",
    "ibanId": "IBAN ID",
    "id": "ID",
    "includeAllAttachments": "Include all attachments",
    "includedInContract": "Included in contract",
    "indexChange": "Change",
    "indexClauseDetails": "Index clause details",
    "indexTransfer": "Transfer",
    "inlineDocuments": "Inline documents",
    "internal": "Internal",
    "internalObjectionDeadline": "Internal objection deadline",
    "interval": "Interval",
    "intervalUnit": "Interval unit",
    "inventoryNumber": "Inventory number",
    "invoice": "Invoice",
    "invoiceId": "Invoice ID",
    "invoiceIssueDate": "Invoice issue date",
    "invoiceIssueDates": "Invoice issue dates",
    "invoiceIssueDatesShort": "Inv. date",
    "invoiceIssuerLegalName": "CI Name",
    "invoiceItemSource": "Source",
    "invoiceObjectionDeadline": "Objection deadline",
    "invoicePeriodEnd": "Period end",
    "invoicePeriodEnds": "Invoice period ends",
    "invoicePeriodEndsShort": "From",
    "invoicePeriodStart": "Period start",
    "invoicePeriodStarts": "Invoice period starts",
    "invoicePeriodStartsShort": "To",
    "isActive": "Active",
    "isActiveValue": "Active",
    "isAlwaysVisible": "always visible",
    "isClassificationNotApplicable": "Classification not applicable",
    "isClassified": "Classified",
    "isClassifiedShort": "Class.",
    "isDraft": "Draft",
    "isDraftShort": "Temp",
    "isFlatRate": "Flat rate",
    "isGroupAdmin": "Group admin",
    "isHeatingCostsCompliantHKVO": "Heating costs compliant HKVO",
    "isIndexPayment": "Index Clause",
    "isInline": "Attachment",
    "isInternal": "Internal",
    "isMainAccount": "Main account",
    "isNewTicket": "Create new ticket",
    "isOptional": "Optional",
    "isPublic": "Visible for customers",
    "isRecurring": "Recurring",
    "isSeyboldUser": "Seybold user",
    "issueDate": "Issue date",
    "issueDateShort": "Inv. date",
    "issuerLegalName": "Issuer legal name",
    "isTemplateEditable": "Editable:",
    "isTemplateEditableFalse": "placeholders",
    "isTemplateEditableTrue": "all",
    "jobTitle": "Job title",
    "languageOfCorrespondence": "Language of correspondence",
    "lastAdjustment": "Last adjustment",
    "lastCost": "Last cost",
    "lastEmailSentAt": "last email sent at date",
    "lastEmailSentTo": "last email sent to",
    "lastName": "Last name",
    "lastPerformedDate": "Last performance date",
    "lastPossibleContractEnd": "last possible contract end",
    "lease": "Leasing",
    "lessThan": "Less than",
    "lessThanOrEqual": "Less than or equal",
    "lineItem": "Objection line item",
    "lineItemName": "Line item name",
    "lineItemPositionName": "Line item position name (internal)",
    "lineItemPositionNameShort": "Int. name",
    "lineItemStatus": "Line Item Status",
    "location": "Location",
    "locationAddress": "Address",
    "locationArea": "Area",
    "locationId": "Location ID",
    "locationIdShort": "Loc-ID",
    "locationName": "Location name",
    "locations": "Locations",
    "locationToPartner": "Partner",
    "logText": "Log message",
    "mailContent": "Mail content",
    "mailTemplate": "Mail template",
    "Maintenance Contract": "Maintenance Contract",
    "maintenanceStatuses": "Maintenance Statuses",
    "mainUsage": "Main usage",
    "managerName": "Manager name",
    "manufacturer": "Manufacturer",
    "markAsUnread": "Mark as unread",
    "markDone": "Mark as done",
    "maxCount": "Max possible extentions",
    "maxCountShort": "Max.",
    "message": "Message",
    "mimeType": "Document type",
    "mobile": "Mobile",
    "model": "Model",
    "modified": "modified",
    "modifiedAt": "Modified at",
    "month": "Month",
    "moveinTime": "Move-in time",
    "moveoutTime": "Move-out time",
    "name": "Name",
    "nameExternal": "External",
    "nameOnStatement": "Name on statement",
    "negotiationAll": "all",
    "negotiationGreen": "green",
    "negotiationNone": "none",
    "negotiationRed": "red",
    "negotiationYellow": "yellow",
    "new": "New",
    "newChildPosition": "New child position",
    "newTicket": "New ticket",
    "nextDueDate": "Next due date",
    "nextPossibleContractEnd": "Next possible contract end",
    "nextStepAction": "Next step",
    "no": "No",
    "noAttachments": "No Attachments",
    "noPlugins": "No plugins",
    "note": "Note",
    "notes": "Notes",
    "noteText": "Note text",
    "notice": "Notice",
    "noticePeriod": "Notice period",
    "noticePeriodShort": "Notice",
    "noticePeriodUnit": "Notice period unit",
    "noTicketFound": "No ticket found",
    "notIncluded": "Not included",
    "noTriggers": "No triggers",
    "number": "Number",
    "numberOfUses": "Number of uses",
    "numberValue": "Number value",
    "numberValueShort": "Num",
    "objectionDeadline": "Objection deadline",
    "objectionItemStatus": "Objection Status",
    "objectionItemStatusShort": "solved?",
    "objectionStatus": "Objection status",
    "offerGreenAdditionalConcession": "Additional Concession",
    "offerGreenAdditionalConcessionShort": "Add.",
    "offerGreenMaxDemand": "Maximum Demand",
    "offerGreenMaxDemandShort": "Max",
    "offerGreenSolutionProposal": "Solution Proposal",
    "offerGreenSolutionProposalShort": "Solution",
    "offerGreenStandardConcession": "Standard Concession",
    "offerGreenStandardConcessionShort": "Std.",
    "offerRedAdditionalConcession": "Additional Concession",
    "offerRedAdditionalConcessionShort": "Add.",
    "offerRedMaxDemand": "Maximum Demand",
    "offerRedMaxDemandShort": "Max",
    "offerRedSolutionProposal": "Solution Proposal",
    "offerRedSolutionProposalShort": "Solution",
    "offerRedStandardConcession": "Standard Concession",
    "offerRedStandardConcessionShort": "Std.",
    "offerYellowAdditionalConcession": "Additional Concession",
    "offerYellowAdditionalConcessionShort": "Add.",
    "offerYellowMaxDemand": "Maximum Demand",
    "offerYellowMaxDemandShort": "Max",
    "offerYellowSolutionProposal": "Solution Proposal",
    "offerYellowSolutionProposalShort": "Solution",
    "offerYellowStandardConcession": "Standard Concession",
    "offerYellowStandardConcessionShort": "Std.",
    "oneTimeContribution": "One time contribution",
    "operatingcostinvoice": "Operating cost invoice",
    "operator": "Operator",
    "optional": "optional",
    "optionsAvailable": "Options available",
    "orderBy": "Order by",
    "overdue": "Overdue",
    "overdueDaysSince": "Overdue",
    "ownerName": "Owner name",
    "page": "Page",
    "parentId": "Parent ID",
    "partnephonerCount": "Partner group count",
    "partnephonerCountShort": "PGs",
    "partner": "Partner",
    "partnerAddress": "Address",
    "partnerBankingAccount": "Partner banking account",
    "partnercompany": "Partner company",
    "partnerCount": "Partner count",
    "partnerCountShort": "No.",
    "partnerGroup": "Partner group",
    "partnerGroupId": "Partner group ID",
    "partnerGroupIdShort": "Pg-ID",
    "partnerGroups": "Partner groups",
    "partnerName": "Partner name",
    "partners": "Partners",
    "passThrough": "Pass through",
    "payment": "Payment",
    "payments": "Payments",
    "paymentType": "Payment type",
    "performedDate": "Performed date",
    "periodEnd": "Period end",
    "periodEndShort": "to",
    "periodStart": "Period start",
    "periodStartShort": "from",
    "phone": "Phone",
    "phoneOrInternetType": "Type of internet or phone",
    "pointOfSale": "Point of sale",
    "pointOfSale_customer_customerGroup_name": "Customer group",
    "pointOfSale_name": "Point of sales",
    "pointOfSaleId": "POS ID",
    "pointOfSaleName": "POS name",
    "pointOfSaleNames": "POS",
    "pointOfSaleNameShort": "Name",
    "pointOfSales": "Point of sales",
    "pointOfSalesToArea": "Areas",
    "pos": "POS",
    "posId": "ID Point Of Sale",
    "posIdShort": "POS ID",
    "positionCount": "Number of Positions",
    "positionCountShort": "Pos. count",
    "positionEndDates": "End Date",
    "positionIds": "Position IDs",
    "positionNames": "Position Names",
    "positionNamesShort": "Positions",
    "positions": "Objection positions",
    "positionStartDates": "Start Date",
    "posName": "POS name",
    "postalCode": "Postal code",
    "postalCodeShort": "ZIP",
    "postCleaningIsRequired": "Post cleaning is required",
    "preferences": {
      "showContractactionsTable": "Contract actions",
      "showEmailsDoughnutChart": "Email chart",
      "showEmailsUnclassifiedTable": "Unclassified emails",
      "showLatestOpenTicketsTable": "Actual open tickets",
      "showTicketsDoughnutChart": "Ticket chart",
      "showUrgentOpenTicketsTable": "Urgent open tickets",
      "ticketShowConfirm": "Confirm next step",
      "ticketShowPersonalNotes": "Own notes",
      "ticketShowPreviewNotification": "Preview to next step"
    },
    "preferenceSettings": "Preferences",
    "preferenceSettingsDashboard": "Dashboard settings",
    "preferenceSettingsTicket": "Ticket settings",
    "priorityLevel": "priority",
    "procdefUrl": "process step URL",
    "processAddStep": "Create new step",
    "processAddStepConnect": "Create new step and link it",
    "processAddUiPlugin": "Add action component",
    "processAssignedTeam": "Assigned team",
    "processAssignToNewStep": "Assign to a new step",
    "processConnectPlugin": "Link UI plugin",
    "processConnectStep": "Create new option",
    "processDeadline": "Deadline for whole process (workdays)",
    "processDeadlinedAt": "Final deadline",
    "processDownload": "Download process JSON",
    "processExternal": "External process",
    "processFinishTask": "Complete task",
    "processGotoExternalStep": "Switch to external process",
    "processGotoStart": "Back to start",
    "processInitTitle": "Name & describe the process",
    "processIsExternalStep": "Is an external process step",
    "processIsUploaded": "Uploaded:",
    "processLoadFromJSON": "Load process",
    "processName": "Process",
    "processNewOption": "New option",
    "processOptionName": "Linktext",
    "processOptionNextStep": "Connect a step",
    "processOptionNextStepAssignTeam": "Assign team",
    "processOptionsNextStep": "Options for next steps",
    "processPasteJSON": "Paste JSON",
    "processPreview": "Preview",
    "processRemoveOption": "Remove option",
    "processRemovePlugin": "Remove plugin",
    "processRemoveTrigger": "Remove trigger",
    "processSlip": "Process slip",
    "processStep": "Step",
    "processStepDelete": "Delete step",
    "processStepDescription": "Step description",
    "processStepEdit": "Edit step",
    "processStepIsEnd": "Is final step",
    "processStepName": "Process step name",
    "processStepTriggers": "Assign trigger to step",
    "processStepUiPlugins": "Action components",
    "processTree": "Tree view",
    "processUnlinkOption": "Remove link",
    "processUploadJSON": "Upload JSON",
    "profile": "Profile",
    "propertyDescription": "Description",
    "Purchase Agreement": "Purchase agreement",
    "rawdata": "Raw data",
    "receiptDate": "Receipt Date",
    "receiveDate": "Receive date",
    "recentComments": "Recent comments",
    "recurringContribution": "Recurring contribution",
    "recurringPayment": "Recurring payment",
    "reference": "Reference",
    "region": "Region",
    "remaining": {
      "farFuture": "In the distant future",
      "lessThanHalfYear": "Less than half a year",
      "lessThanMonth": "Less than a month",
      "lessThanQuarter": "Less than three months",
      "lessThanYear": "Less than a year"
    },
    "Rental": "Rental",
    "rentalSpace": "Rental space",
    "reply": "Reply",
    "resiliationDate": "Resiliation date",
    "resolvedConditionType": "Condtion type",
    "responsibleRole": "Responsible role",
    "retroactiveAdjustment": "Retroactive adjustment",
    "reviewer1Date": "Date of 1st review",
    "reviewer1Name": "Name of 1st reviewer",
    "reviewer2Date": "Date of 2nd review",
    "reviewer2Name": "Name of 2nd reviewer",
    "reviewPhase": "Review phase",
    "role": "Role",
    "salutation": "Salutation",
    "secondStampingNotOk": "Unchecked",
    "selectAll": "Select all",
    "selectContract": "Select contract",
    "selected": "Selected",
    "selectedColumns": "Selected columns",
    "selectPointOfSale": "Select point of sale",
    "senderEmail": "Email",
    "senderEmails": "Emails",
    "senderName": "Sender",
    "serialNumber": "Serial number",
    "Service Agreement": "Service agreement",
    "serviceconditions": "Contract conditions",
    "servicecontact": "Contact",
    "servicecontractactions": "Contract actions",
    "serviceobjectdocuments": "Documents",
    "serviceobjectmaintenances": "Maintenance entries",
    "serviceobjectmaintenancestatus": "Maintenance status",
    "serviceobjectpartners": "Partners",
    "serviceObjects": "Service objects",
    "serviceObjectTemplate": "Service object template",
    "serviceobjecttickets": "Tickets",
    "serviceObjectTypes": "Service object types",
    "servicepayment": "Payment",
    "settlementResultGross": "Settlement result gross",
    "settlementResultNet": "Settlement result net",
    "sfmPosition": "SFM Position",
    "sfmpositionchildren": "Children",
    "sfmPositionName": "SFM Position Name",
    "shortDescription": "Short description",
    "showList": "Show list",
    "signatureNotOk": "Not signed yet",
    "signatureOk": "Signed",
    "signatureRequestNotOk": "Not ready for signature",
    "signatureRequestOk": "Ready for signature",
    "signatureRequestPending": "Signature pending",
    "signatureRequestRefused": "Signature refused",
    "signatureRequests": "Yousign",
    "signerAdd": "Add signer",
    "signerCustom": "Custom signer",
    "signerCustomer": "Customer",
    "signerDefault": "Default signer",
    "signerFirst": "Initial signer",
    "signerFollowUp": "{count}. Folgeunterzeichner",
    "size": "Size",
    "sizeShort": "Sz.",
    "skip": "Skip",
    "solutionProposals": "Solution proposals",
    "spaceValue": "Space value",
    "speed": "Speed",
    "stamped": "Stamped",
    "stampedShort": "Stamp.",
    "stampingNotOk": "Unstamped",
    "stampingStep1": "First review",
    "stampingStep2": "Second review",
    "startDate": "Start date",
    "startsWith": "Starts with",
    "statedCustomerPrepaymentNet": "Stated customer prepayment net",
    "status": "Status",
    "statusActions": "Actions",
    "stepActionElement": "UI-Plugin",
    "stepDeadline": "Deadline for a step",
    "stepDeadlinedAt": "To do until",
    "stepLinkname": "Linnkname of step",
    "stepTriggerElement": "Trigger",
    "street": "Street",
    "streetNumber": "Street number",
    "stringValue": "String value",
    "subject": "Subject",
    "sumAreaSpaces": "SUM area spaces",
    "summary": "Summary",
    "SupplyContract": "Supply contract",
    "supposedActionEnd": "Supposed action end",
    "tableSettingsFontsize": "Font Size",
    "tableSettingsFooterPagination": "Footer Pagination",
    "tableSettingsGrid": "Grid",
    "tableSettingsHdlBehaviour": "Table Behavior",
    "tableSettingsHdlColumns": "Visible Columns",
    "tableSettingsHdlExportCSV": "Export CSV",
    "tableSettingsHdlLayout": "Table Layout",
    "tableSettingsHdlSize": "Size",
    "tableSettingsInstantEdit": "Instant Editing",
    "tableSettingsMultiselect": "Multiselect Checkboxes",
    "tableSettingsStripedRows": "Striped Rows",
    "tabsAll": "All",
    "tags": "Tags",
    "tasks": "Tasks",
    "taxinvoices": "TA invoices",
    "team": "Assigned team",
    "teamDescription": "Team Description",
    "teamName": "Team Name",
    "teams": "Teams",
    "templateIsForced": "Fixed Template",
    "threshold": "Threshold",
    "ticket": "Ticket",
    "ticketId": "Linked ticket",
    "ticketIdShort": "Ticket",
    "ticketLinked": "Linked Ticket",
    "ticketLinkedShort": "Ticket",
    "ticketNumber": "Ticket number",
    "tickets": "Tickets",
    "ticketStatus": "Ticket status",
    "title": "Title",
    "titleUiPluginParam": "Sample title",
    "total": "Sum",
    "totalAccumulatedMaintenanceCosts": "Total accumulated maintenance costs",
    "totalAmount": "Total amount",
    "totalAmountShort": "Sum",
    "totalArea": "Total area",
    "totalAreaShort": "m²",
    "totalUnitArea": "Total area",
    "type": "Type",
    "typeName": "Type name",
    "typeOfUse": "Type of use",
    "unit": "Unit",
    "unitName": "Unit name",
    "unrelatedAttachments": "Unrelated attachments",
    "upload": "Upload",
    "uploaded": "Uploaded",
    "uploadedAmount": "One document uploaded|{count} documents uploaded",
    "uploadedDocument": "Uploaded document",
    "uploadedNone": "No documents uploaded",
    "uploadFile": "Upload file",
    "uploadFiles": "Upload files",
    "usageType": "Usage type",
    "usageTypeAllocationspaceValue": "Allocation space value",
    "usageTypeMainUsage": "Main usage",
    "usagetypeName": "Usage type name",
    "usageTypeRentalspaceValue": "Rental space value",
    "usageTypeValidFrom": "Valid from",
    "usageTypeValidTo": "Valid to",
    "userEmail": "E-mail: {email}",
    "userName": "User name: {userName}",
    "users": "Users",
    "validFrom": "Valid from",
    "validTo": "Valid to",
    "value": "Value",
    "vat": "VAT",
    "vatRate": "Tax rate",
    "vatRateShort": "Vat.",
    "version": "Version",
    "versionAddress": "Address Version",
    "versionAddressShort": "AV",
    "versionShort": "V.",
    "view": "View",
    "viewlengthLimit": "Max. entries",
    "widgetIsClassifiedFalse": "uncategorized",
    "widgetIsClassifiedTrue": "categorized",
    "widgetStatusTICKETSTATUS_CLOSED": "closed",
    "widgetStatusTICKETSTATUS_NEW": "new",
    "withAttachments": "With attachments",
    "withoutAttachments": "Attachments separately",
    "year": "Year",
    "yes": "Yes",
    "youSignApiKey": "Yousign API key",
    "zip": "ZIP code"
  },
  "messages": {
    "checklistAllChecked": "All items are checked",
    "checklistNotAllChecked": " Not all items are checked",
    "contractsLastCreated": "Last created contracts",
    "contractsPluginReady": "A contract of this type already in place | {count} contracts of this type already in place",
    "createdByTicket": "Created by ticket",
    "documentDetailClassificationAttachment": "Since this document is an attachment, point of sale, document type and ticket are mandatory or none of them.",
    "documentDetailClassificationUploadedDocument": "Since this document is an uploaded document, point of sale and document type is mandatory. Ticket is optional.",
    "documentEncrypted": "The document is encrypted and cannot be processed. We are working on support for encrypted documents in future versions.",
    "loadingPDF": "PDF being loaded",
    "noData": "No data available",
    "noInlinePreview": "No preview available",
    "noResults": "No Results",
    "noTableData": "No data available",
    "noTableFilterData": "No result for this filter setting",
    "toggledFullscreenView": "Switched to single view",
    "toggledSplitView": "Switched to split view",
    "uiPluginAllChecked": "Task is finished",
    "uiPluginNotAllChecked": "Task remains yet unfinished",
    "viewmode": "View mode"
  },
  "months": {
    "1": "January",
    "2": "February",
    "3": "March",
    "4": "April",
    "5": "May",
    "6": "June",
    "7": "July",
    "8": "August",
    "9": "September",
    "10": "October",
    "11": "November",
    "12": "December"
  },
  "navigation": {
    "access": "Access",
    "accountDataRelated": "Account data related",
    "address": "Address",
    "administration": "Administration",
    "areas": "Areas",
    "areaTypes": "Area types",
    "attributeTranslations": "Attribute translations",
    "authorizations": "Authorizations",
    "choices": "Choices",
    "cities": "Cities",
    "claimTypes": "Claim types",
    "classificationOfDocumentEntries": "Inbox",
    "companies": "Companies",
    "company": "Seybold internal",
    "companyDatabase": "Customers",
    "conditionList": "Condition list",
    "configInvoiceAndContradictionRelatedData": "Config invoice and contradiction {{ t('text.relatedData') }}",
    "configuration": "Configuration",
    "contactPerson": "Contact person",
    "contactsCustomers": "Contacts",
    "contactsInternal": "Contacts",
    "contactsPartners": "Contacts",
    "contractCriteriaTypes": "Contract criteria types",
    "contractDataRelated": "Contract data related",
    "contracts": "Contracts",
    "contractsTermsAndConditions": "Contracts - Terms and conditions",
    "contractTitles": "Contract titles",
    "contractTypes": "Contract types",
    "contradictionPackages": "Contradiction packages",
    "costinvoiceobjections": "Cost Invoice Objections",
    "costTypes": "Cost types",
    "countries": "Countries",
    "criteriaAndChoices": "Criteria and choices",
    "crud": "CRUD",
    "currencies": "Currencies",
    "customergroups": "Groups",
    "customers": "Customers",
    "dashboard": "Dashboard",
    "dashboardOfBoards": "Dashboard of boards",
    "dashboardTickets": "Dashboard tickets",
    "deadlineList": "Deadline list",
    "documentContractType": "Document contract type",
    "documents": "Dokuments",
    "documentTypes": "Document Types",
    "facilityServices": "Facility services",
    "favorites": "Favorites",
    "functions": "Functions",
    "geography": "Locations",
    "import": "Import",
    "importContract": "Import contract",
    "importFunction": "Import function",
    "importStandard": "Import standard",
    "inbox": "Inbox",
    "indexClauses": "Index clauses",
    "inspectionResults": "Inspection results",
    "invoiceAndContradictionData": "Invoice and contradiction data",
    "invoiceCriteria": "Invoice criteria",
    "invoiceValueTypes": "Invoice value types",
    "kanbanTickets": "Kanban tickets",
    "kanbanTicketsConfiguration": "Kanban tickets",
    "language": "Language",
    "languages": "Languages",
    "listOfTicketsAndTasks": "List of tickets and tasks",
    "locations": "Locations",
    "locationTypes": "Location types",
    "logout": "Logout",
    "main": "My Zelos",
    "masterdata": "Masterdata",
    "maturityTypes": "Maturity types",
    "menu": "Menu",
    "miscellaneous": "Miscellaneous",
    "monthlyindex": "Monthly Index",
    "myTasksAndTickets": "My tasks and tickets",
    "myTasksAndTicketsConfiguration": "My tasks and tickets",
    "newBusiness": "New business",
    "objectDataRelated": "Object data related",
    "operatingcostinvoices": "Operation Cost Invoices",
    "operations": "Operations",
    "partnerCompanies": "Partner companies",
    "partnercompanyDatabase": "Partners",
    "partnergroups": "Groups",
    "partners": "Partners",
    "partnerTypes": "Partner types",
    "payments": "Payments",
    "pointOfSales": "Point of sales",
    "pointofsales": "Points of sale",
    "processes": "Processes",
    "products": "Products",
    "rating": "Rating",
    "recurringPayment": "Recurring payment",
    "recurringPaymentTypes": "Recurring payment types",
    "rentalsAndContracts": "Documents",
    "resultCategories": "Result categories",
    "rights": "Rights",
    "salutions": "Salutations",
    "savingTypes": "Saving types",
    "servicecontracts": "Service contracts",
    "serviceobjects": "Service objects",
    "serviceObjects": "Service objects",
    "sfmpositions": "SFM - Positions",
    "tableGroups": "Table groups",
    "tables": "Tables",
    "tags": "Tags",
    "tapsInvoicePositions": "TAPs - invoice positions",
    "taxinvoices": "TA - Invoices",
    "teams": "Teams",
    "textModules": "Text modules",
    "textTemplates": "Text templates",
    "textTemplateVariables": "Text template variables",
    "ticketListIssue": "Ticket list issue",
    "ticketPriorities": "Ticket priorities",
    "tickets": "Tickets",
    "ticketTypes": "Ticket types",
    "trackRecord": "Track record",
    "translations": "Translations",
    "units": "Units",
    "usageTypes": "Usage types",
    "userAdministration": "User administration",
    "userProfile": "Profile",
    "users": "Users",
    "userTypes": "User types"
  },
  "pages": {
    "403": {
      "back2Home": "Back home",
      "headline": "Access denied",
      "opener": "The requested resource currently is not available for you",
      "title": "Access not allowed"
    },
    "404": {
      "back2Home": "Back home",
      "headline": "This page does not exist",
      "opener": "Check the path in your URL",
      "title": "Page not found"
    },
    "access": {
      "title": "Access"
    },
    "address": {
      "title": "Address"
    },
    "administration": {
      "title": "Administration"
    },
    "areas": {
      "title": "Areas"
    },
    "areasDetail": {
      "title": "Area Detail"
    },
    "areasDetailEdit": {
      "title": "Edit Area Detail"
    },
    "areasNew": {
      "title": "New Area"
    },
    "areaTypes": {
      "title": "Area Types"
    },
    "attributeTranslations": {
      "title": "Attribute Translations"
    },
    "authorizations": {
      "title": "Authorizations"
    },
    "choices": {
      "title": "Choices"
    },
    "cities": {
      "title": "Cities"
    },
    "claimTypes": {
      "title": "Claim Types"
    },
    "classification": {
      "actions": "Actions",
      "attachmentHeadline": "Mail attachment",
      "emailHeadline": "Email",
      "inbox": "Inbox",
      "message": "Message",
      "selectMessage": "Select an item to view its details.",
      "tabs": {
        "all": "All",
        "received": "Incoming",
        "received:thisWeek": "this week",
        "received:today": "today",
        "status": "Status",
        "status:closed": "processed",
        "status:open": "unprocessed"
      },
      "title": "Classification of Document Entries"
    },
    "classificationOfDocumentEntries": {
      "title": "Classification of Document Entries"
    },
    "classificationOfDocumentEntriesV2": {
      "title": "Classification of Document Entries V2"
    },
    "companies": {
      "title": "Companies"
    },
    "conditionList": {
      "title": "Condition List"
    },
    "configurationKanbanTickets": {
      "title": "Configuration Kanban Tickets"
    },
    "contactpersons": {
      "title": "Contact Persons"
    },
    "contactpersonsDetail": {
      "title": "Contact Person Detail"
    },
    "contactpersonsDetailEdit": {
      "title": "Edit Contact Person"
    },
    "contactpersonsNew": {
      "title": "New Contact Person"
    },
    "contractCriteriaTypes": {
      "title": "Contract Criteria Types"
    },
    "contracts": {
      "extensionValue": "{value} {unit}",
      "headlineExistingContracts": "Existing Contracts",
      "headlineNewContract": "New Contract",
      "tabs": {
        "contractType": "Contract type",
        "status": "Status",
        "status:available": "Status: Available"
      },
      "title": "Contract"
    },
    "contractsDetail": {
      "title": "Contract Detail"
    },
    "contractsDetailConditions": {
      "title": "Contract Condition Detail"
    },
    "contractsDetailConditionsDetailEdit": {
      "title": "Edit Contract condition"
    },
    "contractsDetailConditionsNew": {
      "title": "New Contract condition"
    },
    "contractsDetailContactEdit": {
      "title": "Edit contact"
    },
    "contractsDetailContactNew": {
      "title": "New contact"
    },
    "contractsDetailContractactions": {
      "title": "Contract action Detail"
    },
    "contractsDetailContractactionsDetailEdit": {
      "title": "Edit Contract action"
    },
    "contractsDetailContractactionsNew": {
      "title": "New Contract action"
    },
    "contractsDetailEdit": {
      "title": "Edit Contract"
    },
    "contractsDetailNew": {
      "title": "New Contract"
    },
    "contractsDetailPaymentEdit": {
      "title": "Edit payment"
    },
    "contractsDetailPaymentNew": {
      "title": "New payment"
    },
    "contractsNew": {
      "title": "New Contract"
    },
    "contractTitles": {
      "title": "Contract Titles"
    },
    "contractTypes": {
      "title": "Contract Types"
    },
    "contradictionPackages": {
      "title": "Contradiction Packages"
    },
    "costInvoice": {
      "tabs": {
        "status": "Status",
        "status:clear": "clear",
        "status:unclear": "unclear"
      },
      "title": "Cost invoice"
    },
    "costinvoiceobjections": {
      "selectLineItem": "Select an invoice line item",
      "tabs": {
        "negotiationStatus": "Negotiation phase",
        "status": "Objection status"
      },
      "title": "Cost Invoice Objections"
    },
    "costinvoiceobjectionsDetail": {
      "title": "Objection Detail"
    },
    "costinvoiceobjectionsDetailEdit": {
      "title": "Edit Objection"
    },
    "costinvoiceobjectionsNew": {
      "title": "New Objection"
    },
    "costTypes": {
      "title": "Cost Types"
    },
    "countries": {
      "title": "Countries"
    },
    "criteriaAndChoices": {
      "title": "Criteria and Choices"
    },
    "crud": {
      "title": "CRUD"
    },
    "currencies": {
      "title": "Currencies"
    },
    "customergroups": {
      "title": "Customer Groups"
    },
    "customergroupsDetail": {
      "title": "Customer Group Detail"
    },
    "customergroupsDetailEdit": {
      "title": "Edit Customer Group"
    },
    "customergroupsNew": {
      "title": "New Customer Group"
    },
    "customers": {
      "tabs": {
        "all": "All",
        "group": "Group",
        "received": "Incoming",
        "received:thisWeek": "this week",
        "received:today": "today",
        "status:closed": "processed",
        "status:open": "unprocessed"
      },
      "title": "Customers"
    },
    "customersDetail": {
      "title": "Customer Detail"
    },
    "customersDetailEdit": {
      "title": "Edit Customer"
    },
    "customersNew": {
      "title": "New Customer"
    },
    "dashboard": {
      "contractactions": "Contractactions",
      "emailsChart": "Emails",
      "emailsUnclassified": "Emails uncategorized",
      "latestOpenTickets": "Most recent open tickets",
      "openTickets": "Open Tickets",
      "ticketsChart": "Tickets",
      "title": "My Zelos",
      "urgentOpenTickets": "Most urgent tickets"
    },
    "dashboardBoard": {
      "title": "Dashboard Board"
    },
    "dashboardTicket": {
      "title": "Dashboard Ticket"
    },
    "deadlineList": {
      "title": "Deadline List"
    },
    "documentContractType": {
      "title": "Document Contract Type"
    },
    "documents": {
      "tabs": {
        "all": "All",
        "documentType": "Kind",
        "status": "Status",
        "status:classified": "categorized",
        "status:unclassified": "uncategorized",
        "type": "Type",
        "type:csv": "CSV",
        "type:documents": "Documents",
        "type:excel": "Excel",
        "type:images": "Images",
        "type:other": "Other",
        "type:pdf": "PDF",
        "type:word": "Word"
      },
      "title": "Documents",
      "uploadedHeadline": "Successfully uploaded Files",
      "uploadExplanation": "Drag and drop files to here to upload.",
      "uploadHeadline": "Upload of documents",
      "uploadInProgressMessage": "Upload in progress",
      "viewHeadline": "Document view"
    },
    "documentsBatchClassify": {
      "subtitle": "Classify documents in batch",
      "title": "Batch classification of documents"
    },
    "documentsDetail": {
      "availableDocuments": "Available documents",
      "batchClassification": "Batch classification",
      "title": "Document",
      "uploadedHeadline": "Successfully Uploaded Files",
      "uploadExplanation": "Drag files here to upload them",
      "uploadHeadline": "Document Upload",
      "uploadInProgressMessage": "Upload in Progress",
      "viewHeadline": "Document View"
    },
    "documentTypes": {
      "title": "Document Types"
    },
    "emails": {
      "headline": "HDL Emails",
      "title": "E-Mails"
    },
    "emailsDetail": {
      "headline": "HDL Detail Email",
      "title": "write an email"
    },
    "emailsNew": {
      "headline": "HDL new Email",
      "title": "New Email"
    },
    "facilityServiceObjects": {
      "title": "Facility Service Objects"
    },
    "functions": {
      "title": "Functions"
    },
    "home": {
      "title": "Home"
    },
    "import": {
      "title": "Import"
    },
    "importContract": {
      "title": "Import Contract"
    },
    "importStandard": {
      "title": "Import Standard"
    },
    "indexClauses": {
      "title": "Index Clauses"
    },
    "inspectionResults": {
      "title": "Inspection Results"
    },
    "invoiceCriteria": {
      "title": "Invoice Criteria"
    },
    "invoiceValueTypes": {
      "title": "Invoice Value Types"
    },
    "languages": {
      "title": "Languages"
    },
    "listOfTickets": {
      "title": "List of Tickets"
    },
    "locations": {
      "title": "Locations"
    },
    "locationTypes": {
      "title": "Location Types"
    },
    "login": {
      "logInButton": "Log in with Entra",
      "opener": "You are not authenticated. Log in with your entra account credentials.",
      "title": "Login"
    },
    "mainKanbanTickets": {
      "title": "Kanban Boards"
    },
    "mainKanbanTicketsKanbanview": {
      "subtitle": "Tasks in Board"
    },
    "mainKanbanTicketsView": {
      "subtitle": "Configuration",
      "title": "Kanban Board"
    },
    "maturityTypes": {
      "title": "Maturity Types"
    },
    "menu": {
      "title": "Menu"
    },
    "monthlyindex": {
      "tabs": {
        "all": "All",
        "year": "Year"
      },
      "title": "Monthly index"
    },
    "myTasksAndTickets": {
      "title": "My Tasks and Tickets"
    },
    "newBusiness": {
      "title": "New Business"
    },
    "operatingcostinvoices": {
      "applySelectedLines": "Apply selected | Apply {count} selected",
      "headlineExistingInvoices": "Existing operating cost invoices",
      "headlineUNewUtilitybill": "New operating cost invoice",
      "headlineUtilitybill": "Operating cost invoice",
      "headlineUtilitybills": "Operating cost invoice|Operating cost invoices",
      "importFromLatestLines": "Import values from former cost invoice",
      "latestUtilitybillExampleValues": "For comparison the former values of the last cost invoice are shown or prefilled",
      "otherUtilitybillExampleValues": "For comparison the values of the selected invoice \"{name}\" are used",
      "selectImportSource": "as template",
      "title": "Cost invoices"
    },
    "operatingcostinvoicesDetail": {
      "title": "Cost invoice"
    },
    "operatingcostinvoicesDetailEdit": {
      "title": "Edit Operating Cost Invoice"
    },
    "operatingcostinvoicesNew": {
      "title": "New Operating Cost Invoice"
    },
    "partnerCompanies": {
      "title": "Partner Companies"
    },
    "partnergroups": {
      "title": "Partner Groups"
    },
    "partnergroupsDetail": {
      "title": "Partner Group Detail"
    },
    "partnergroupsDetailEdit": {
      "title": "Edit Partner Group"
    },
    "partnergroupsNew": {
      "title": "New Partner Group"
    },
    "partners": {
      "title": "Partners"
    },
    "partnersDetail": {
      "title": "Partner Detail"
    },
    "partnersDetailEdit": {
      "title": "Edit Partner"
    },
    "partnersNew": {
      "title": "New Partner"
    },
    "partnerTypes": {
      "title": "Partner Types"
    },
    "payments": {
      "title": "Payments"
    },
    "pointOfSales": {
      "title": "Point of Sales"
    },
    "pointofsales": {
      "title": "Point of Sales"
    },
    "pointofsalesDetail": {
      "title": "Point of Sale Detail"
    },
    "pointofsalesDetailEdit": {
      "title": "Edit Point of Sale"
    },
    "pointofsalesNew": {
      "title": "New Point of Sale"
    },
    "processes": {
      "endOfProcess": "End of process",
      "external": "External process: {procname}",
      "processAssignedTeam": "Assigned team: {team}",
      "processJSON": "Process JSON",
      "tabs": {
        "isDraft": "publication state",
        "isDraft:false": "productive",
        "isDraft:true": "draft"
      },
      "taskClosed": "Task finished",
      "title": "Process modeling",
      "triggersSectionHeadline": "Triggered Actions",
      "uiPluginSectionHeadline": "Action components"
    },
    "processesDetail": {
      "title": "Single Process"
    },
    "processesEdit": {
      "title": "Edit Process"
    },
    "processesNew": {
      "title": "New Process"
    },
    "products": {
      "title": "Products"
    },
    "rating": {
      "title": "Rating"
    },
    "recurringPayment": {
      "title": "Recurring Payment"
    },
    "recurringPaymentTypes": {
      "title": "Recurring Payment Types"
    },
    "resultCategories": {
      "title": "Result Categories"
    },
    "salutions": {
      "title": "Salutations"
    },
    "savingTypes": {
      "title": "Saving Types"
    },
    "servicecontracts": {
      "headlineExistingContracts": "Existing service contracts",
      "headlineNewContract": "New service contract",
      "title": "Service Contract"
    },
    "servicecontractsDetailServiceconditionsDetailEdit": {
      "title": "Edit Contract condition"
    },
    "servicecontractsDetailServiceconditionsNew": {
      "title": "New Contract condition"
    },
    "servicecontractsDetailServicecontactDetailEdit": {
      "title": "Edit contact"
    },
    "servicecontractsDetailServicecontactNew": {
      "title": "New contact"
    },
    "servicecontractsDetailServicecontractactionsDetailEdit": {
      "title": "Edit Contract action"
    },
    "servicecontractsDetailServicecontractactionsNew": {
      "title": "New Contract action"
    },
    "servicecontractsDetailServicepaymentEdit": {
      "title": "Edit payment"
    },
    "servicecontractsDetailServicepaymentNew": {
      "title": "New payment"
    },
    "serviceobjects": {
      "title": "Service Objects"
    },
    "serviceobjectsDetail": {
      "title": "Service Object"
    },
    "serviceobjectsDetailServiceobjectmaintenancestatusDetail": {
      "title": "Service Object Maintenance Status"
    },
    "serviceobjectsDetailServiceobjectmaintenancestatusNew": {
      "title": "New Service Object Maintenance Status"
    },
    "serviceobjectsDetailServiceobjectpartnersDetail": {
      "title": "Service Object Partner"
    },
    "serviceobjectsDetailServiceobjectpartnersNew": {
      "title": "New Service Object Partner"
    },
    "serviceobjectsNew": {
      "title": "New Service Object"
    },
    "sfmpositions": {
      "title": "SFM - Positions"
    },
    "tableGroups": {
      "title": "Table Groups"
    },
    "tables": {
      "title": "Tables"
    },
    "tags": {
      "title": "Tags"
    },
    "tapsInvoicePositions": {
      "title": "Taps Invoice Positions"
    },
    "taxinvoices": {
      "title": "TA Invoices"
    },
    "teams": {
      "title": "Teams"
    },
    "teamsDetail": {
      "title": "Team Detail"
    },
    "teamsDetailEdit": {
      "title": "Edit Team"
    },
    "teamsNew": {
      "title": "New Team"
    },
    "textModules": {
      "title": "Text Modules"
    },
    "textTemplates": {
      "title": "Text Templates"
    },
    "textTemplateVariables": {
      "title": "Text Template Variables"
    },
    "ticketListIssue": {
      "title": "Ticket List Issue"
    },
    "ticketPriorities": {
      "title": "Ticket Priorities"
    },
    "tickets": {
      "noOpenTasks": "No open tasks",
      "notificationNextStepMaintext": "Next Step '{stepName}'",
      "notificationNextStepSubtext": "{stepDescription}",
      "notificationSwitchProcessNextStepMaintext": "Switch to process '{name}'",
      "notificationSwitchProcessNextStepSubtext": "{description}",
      "tabs": {
        "all": "All",
        "status": "Status",
        "status:inProgress": "in progress",
        "status:openOrNew": "open",
        "status:overdue": "overdue",
        "teams": "Team"
      },
      "title": "Tickets",
      "uiplugin": "Action component: {name}",
      "uipluginBlockedMain": "This step is not yet completed",
      "uipluginBlockedSub": "Complete the remaining tasks",
      "uipluginOpenExternal": "Edit on page",
      "uipluginOpenInModal": "Open in modal",
      "uiPlugins": {
        "blueprint": {
          "firstCondition": "First condition",
          "secondCondition": "Second condition"
        },
        "email": {
          "senderEmails": "Emails received"
        }
      }
    },
    "ticketsDetail": {
      "headline": "Ticket #{ticketid}",
      "subheadline": "SUB",
      "ticketName": "[{ticketid}] {customerName}{documentType}{entryDate}",
      "title": "Ticket",
      "unnamed": "task"
    },
    "ticketTypes": {
      "title": "Ticket Types (Coming Soon)"
    },
    "trackRecord": {
      "title": "Track Record"
    },
    "translations": {
      "title": "Translations"
    },
    "undefined": {
      "title": "Unknown page"
    },
    "units": {
      "title": "Units"
    },
    "unknownPage": {
      "title": "Unknown page"
    },
    "usageTypes": {
      "title": "Usage Types"
    },
    "users": {
      "title": "Users"
    },
    "userTypes": {
      "title": "User Types"
    }
  },
  "placeholder": {
    "brevoTemplate": "Select a template",
    "columns": "Visible columns",
    "comment": "New comment",
    "enterLinkName": "Option text",
    "enterStepname": "Step name",
    "name": "Name",
    "note": "New note",
    "noTeamAssigned": "No team assigned",
    "quickfilter": "Quick filter",
    "selectContract": "Select contract",
    "selectCustomer": "Select customer",
    "selectCustomerGroup": "Select customer group",
    "selectExistingAddress": "Select existing address",
    "selectExistingContactPerson": "Select existing contact person",
    "selectOrCreateStep": "Select or create a new step",
    "selectPointOfSale": "Select point of sale",
    "uiPluginParamInputPlaceholder": "Add option`s text"
  },
  "primevue": {
    "clear": "Clear",
    "dayNames": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    "dayNamesMin": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    "firstDayOfWeek": 0,
    "monthNames": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "today": "Today"
  },
  "text": {
    "addMultipleObjectionItems": "Add Multiple Objection Items",
    "attachmentToolbarHeader": "Attachment \"{attachment}\" of {email}",
    "changeStepVisibilities": "Change step option visibilities",
    "contractsFilterActive": "Filter active: only contracts retated to this POS",
    "costOverview": "Cost overview",
    "customerData": "Customer data",
    "deadlines": "Deadlines",
    "deadlinesAndPayments": "Deadlines and payments",
    "detailToolbarHeader": "Detail view of {name}",
    "detailToolbarHeaderDefault": "Detail view",
    "document": "Document",
    "documents": "Documents",
    "emails": "E-Mails",
    "emailToolbarHeader": "Email \"{email}\" from {name}",
    "invoiceDetails": "Invoice Details",
    "invoiceLineItem": "Invoice line item",
    "invoiceLineItems": "Invoice line items",
    "maintenanceStatus": "Maintenance status",
    "masterData": "Master data",
    "noInvoicesFound": "No invoices found",
    "objectionPosition": "Objection position",
    "objectionPositionRelatedItem": "Objection position related items",
    "objectionPositions": "Objection positions",
    "optionalPlugin": "This step is optional",
    "posUsage": "Usage of the point of sale",
    "relatedData": "Related data",
    "selectDocumentToSign": {
      "headline": "Documenst available to sign",
      "text": "Select a document you want to start the signing process for via Yousign"
    },
    "selectedItems": "Selected items",
    "signers": {
      "dosubmit": "Notify signers that a document is ready to be signed",
      "headline": "Signers of '{document}'",
      "requestNotStarted": "Signature request has not been started yet.",
      "requestStarted": "Signature request has been started. The contract partners have been notified to sign the document '{document}' via email.",
      "text": "Add signers to the signing process"
    },
    "signingOngoing": {
      "headline": "Signature state for \"{document}\"",
      "text": "Signature process is ongoing"
    },
    "tapOverview": "TAP Overview",
    "trackRecords": "Track records",
    "trackRecordsTicket": "Ticket history"
  },
  "titletags": {
    "addLang": "Add translation for '{locale}'",
    "back2list": "Back to list",
    "back2origin": "Back to previous page",
    "booleanFalse": "No",
    "booleanTrue": "Yes",
    "change": "Change",
    "chooseFile": "Choose file",
    "chooseFiles": "Choose files",
    "classificationStatusFalse": "Uncategorized",
    "classificationStatusTrue": "Categorized",
    "collapse": "Minimize text",
    "comments": "One|{count} comment|comments",
    "costInvoiceActual": "cost item",
    "costInvoiceDraft": "draft from former cost invoice item",
    "expand": "Show full text",
    "isDraftFalse": "It's productive",
    "isDraftTrue": "It's a draft",
    "notes": "Personal note|notes (stored locally)",
    "pan": "Drag to move (Alt or right mouse button)",
    "processAssigned": "process assigned: '{process}'",
    "processName": "With this label you can find the option inside the ticket",
    "processRemoveOption": "Remove option",
    "processRemovePlugin": "Remove plugin",
    "processRemoveTrigger": "Remove trigger",
    "processStepAssigned": "process step: \"{step}\"",
    "reorderableRows": "Enable custom sorting",
    "reorderableRowsEnabled": "End custom sorting",
    "reset": "Reset",
    "save": "Save",
    "showDashboardSettings": "Dashboard settings",
    "showPreferenceSettings": "Ticketview settings",
    "showTableSettings": "Table Configuration",
    "stampedFalse": "Not stamped",
    "stampedTrue": "Stamped",
    "tasks": "One task has to be fulfilled to move ticket to next step|{count} tasks have to be fulfilled to move ticket to next step",
    "teamAssigned": "team assigned: '{team}'",
    "ticketEntryDate": "Entry date of ticket",
    "ticketProcessDeadlinedAt": "Deadline to finish this ticket: {date}",
    "ticketStatus": "current ticket status: '{status}'",
    "ticketStepDeadlinedAt": "You should finish this step until {date}",
    "toggleRefresh": "Refresh",
    "toggleSplitviewOff": "Split View",
    "toggleSplitviewOn": "Full View",
    "toggleToEditViewModeOnDblClick": "Return to view mode on doubleclick",
    "toggleToEditVodeOnDblClick": "Edit on doubleclick"
  },
  "toast": {
    "create": {
      "detail": "Entry has been created"
    },
    "default": {
      "detail": "Request has been executed",
      "summary": "Done"
    },
    "delete": {
      "detail": "Entry has been deleted"
    },
    "error": "Error",
    "error403": "Forbidden",
    "errors": {
      "brokenJSON": "broken JSON format",
      "CANNOT_BE_CREATED": "Item cannot be created",
      "CANNOT_BE_DELETED": "Item cannot be deleted",
      "CANNOT_BE_FOUND": "Item cannot be found",
      "CANNOT_BE_UPDATED": "Item cannot be updated",
      "Constraint violation exception": "File already exists",
      "DOCUMENT_FIRST_REVIEWER_MISSING": "First reviewer missing! Stamping is not correct.",
      "encrypted": "File is encrypted and cannot be uploaded",
      "FILE_DOWNLOAD_ERROR": "Error on loading file",
      "FILE_NOT_FOUND": "File cannot be found (404).",
      "Internal server error": "Internal server error",
      "noEmailOnPOS": "No email assigned to POS"
    },
    "load": {
      "detail": "Data list reloaded"
    },
    "position": {
      "detail": "Globally changed for all users",
      "summary": "Sort order changed"
    },
    "send": {
      "detail": "Email has been sent"
    },
    "trigger": {
      "detail": "been triggered",
      "summary": "Trigger '{id}'"
    },
    "update": {
      "detail": "Entry has been updated",
      "multi": {
        "detail": "{count} entries have been updated",
        "summary": "Multiple entries updated"
      }
    }
  }
}
